var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpresa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.714,
    height: 89.831,
    viewBox: "0 0 98.714 89.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#3f66b3;stroke:#f7f8f9;fill-rule:evenodd}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__ic-actions-bag",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_107",
    "data-name": "Vrstva 107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_67",
    d: "M85.39 19.766h-8.883v-4.441A13.325 13.325 0 0 0 63.182 2h-26.65a13.325 13.325 0 0 0-13.324 13.325v4.442h-8.883A13.325 13.325 0 0 0 1 33.091v44.416a13.325 13.325 0 0 0 13.325 13.324H85.39a13.325 13.325 0 0 0 13.324-13.324V33.091A13.325 13.325 0 0 0 85.39 19.766zm-53.3-4.442a4.442 4.442 0 0 1 4.442-4.442h26.65a4.442 4.442 0 0 1 4.442 4.442v4.442H32.091zm57.74 62.182a4.442 4.442 0 0 1-4.442 4.442H14.325a4.442 4.442 0 0 1-4.442-4.442V33.091a4.442 4.442 0 0 1 4.442-4.442H85.39a4.442 4.442 0 0 1 4.442 4.442z",
    className: "prefix__cls-1",
    "data-name": "Trazado 67",
    transform: "translate(-1 -2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer-2",
    "data-name": "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_17",
    "data-name": "Vrstva 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_68",
    d: "M85.39 19.766h-8.883v-4.441A13.325 13.325 0 0 0 63.182 2h-26.65a13.325 13.325 0 0 0-13.324 13.325v4.442h-8.883A13.325 13.325 0 0 0 1 33.091v44.416a13.325 13.325 0 0 0 13.325 13.324H85.39a13.325 13.325 0 0 0 13.324-13.324V33.091A13.325 13.325 0 0 0 85.39 19.766zm-53.3-4.442a4.442 4.442 0 0 1 4.442-4.442h26.65a4.442 4.442 0 0 1 4.442 4.442v4.442H32.091zm57.74 62.182a4.442 4.442 0 0 1-4.442 4.442H14.325a4.442 4.442 0 0 1-4.442-4.442V33.091a4.442 4.442 0 0 1 4.442-4.442H85.39a4.442 4.442 0 0 1 4.442 4.442z",
    className: "prefix__cls-1",
    "data-name": "Trazado 68",
    transform: "translate(-1 -2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresa);
export default __webpack_public_path__ + "static/media/Empresa.4024f33526f348cb49e0b3ca66b3f25d.svg";
export { ForwardRef as ReactComponent };